export const getLocalesByKey = key => {
  const locales = require('./allinone.json');
  return locales[key];
};
